import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { useIntl } from 'ha/i18n';
import { InfoLine } from 'ha/modules/ListingEdit/components/InfoLine';
import { useAdvancedPricingCalendar } from './useAdvancedPricingCalendar';

const useStyles = makeStyles()(theme => ({
  infoHeader: {
    display: 'flex',
    padding: theme.spacing(4, 3, 0),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4, 0.5, 0),
    },
  },
}));

export const ListingAdvancedPricingInfo: React.FC = () => {
  const { classes } = useStyles();
  const { T } = useIntl();
  const showAdvancedPricingCalendar = useAdvancedPricingCalendar();

  if (!showAdvancedPricingCalendar) return null;

  return (
    <div
      className={classes.infoHeader}
      data-test-locator="ListingInstantBookingBlock/Calendar/Header"
    >
      <InfoLine description={T('date_picker.advanced_pricing.rent_info')} />
    </div>
  );
};
